import styles from './AddNewCompositionRows.module.css';
import NewCompositionRow from './NewCompositionRow';

const AddNewCompositionRows = ({newRowsData, setNewRowsData}) => {
  return (
    <div className={styles.add_new_composition_rows}>
      {newRowsData.map((rowData, index) => (
        <NewCompositionRow 
          key={index}
          rowIndex={index}
          rowData={rowData}
          setNewRowsData={setNewRowsData}
        />
      ))}
    </div>
  )
}

export default AddNewCompositionRows;